<template>
  <v-card class="pa-6">
    <v-btn absolute top right @click="$emit('close')" text icon>
      <v-icon small> mdi-close </v-icon>
    </v-btn>

    <h3 class="my-4 text-center">Adicionar vídeo</h3>

    <v-form ref="form">
      <v-text-field
        v-model="video.title"
        outlined
        :rules="[(v) => !!v || 'Título obrigatório']"
        dense
        placeholder="Adicione um título ao seu vídeo"
      ></v-text-field>

      <v-text-field
        v-model="video.link"
        outlined
        :rules="[(v) => !!v || 'Link obrigatório']"
        dense
        placeholder="Cole aqui o link do vídeo no vimeo"
      ></v-text-field>
    </v-form>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        class="secondary-button mr-0"
        depressed
        @click="submit"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'VideoManage',

  data() {
    return {
      apiService: new ApiService(),
      video: {},
      loading: false,
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.apiService
          .post('video/add', this.video)
          .then(() => {
            this.loading = false
            this.$toast.success('Vídeo salvo com sucesso!')
            this.$emit('confirm')
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style scoped></style>
